<template>
  <div class="leveSet">
    <div class="top">
      <div class="t_l">
        <div class="t_l_item">
          <!-- <em>新增配置项名称</em>
          <a-input allowClear placeholder="请输入配置项名称" v-model="Name"/> -->
          <a-button class="editable-add-btn" @click="handleAdd">添加选项</a-button>
        </div>
        <div class="t_l_item">
          <a-button type="primary" @click="addLevelSet()">保存</a-button>
        </div>
      </div>
    </div>
    <div class="bottom">
      
      <a-table
        :columns="columns"
        :data-source="dataSource"
        :pagination="false"
        bordered
        size="middle"
      >
        <template slot="tit" slot-scope="text, record">
          <a-input v-model="record.header" placeholder="请输入配置项名称"/>
        </template>
        <div slot="action" slot-scope="text,record">
          <a-popconfirm
            title="确定删除？"
            ok-text="确定"
            cancel-text="取消"
            @confirm="deleteLevelSet(record)"
          >
            <a style="color: #f00;">
              <a-icon type="delete"/>删除
            </a>
          </a-popconfirm>
        </div>
      </a-table>
    </div>
  </div>
</template>

<script>
const columns = [
  { title: '序号',
    dataIndex: 'index',
    key: 'index',
    align: 'center',
    width: 50,
    customRender: (text,record,index) => `${index+1}`
  },
  { title: "配置项名称",scopedSlots: { customRender: 'tit' },align:'center'},
  { title: "操作",scopedSlots: { customRender: "action" },align:'center'}

]
export default {
  name:'leveSet',
  data () {
    return {
      columns,
      dataSource:[],
      Name:'',
      gameId:this.$route.query.id,
      num:0
    }
  },
  created () {
    this.levelPagelist()
  },
  methods: {
    handleAdd() {
      this.num ++
      if(this.num < 2){
        const newData = {
          key: this.dataSource.length,
          header: '',
          isadd:true
        };
        this.dataSource.unshift(newData);
      }else{
        this.$message.destroy();
        this.$message.warning('目前仅支持逐条添加，请先保存')
      }
    },
    levelPagelist() {
      let params = {
        pageIndex: 1,
        pageSize: 10,
        tainGameId: this.gameId
      };
      this.$http.levelPagelist(params)
      .then(res => {
          this.dataSource = res.data.data
          localStorage.setItem('levelHeadr',JSON.stringify(res.data.data))
      });
    },
    addLevelSet(){
        this.$message.destroy();
      this.Name = this.dataSource[0].header
      if(!this.Name){
        this.$message.warning('请输入配置项名称')
        return
      }
        if(this.Name.length > 30){
            this.$message.warning('配置项名称字符长度小于30位');
            return
        }
      let formData = new FormData()
      formData.append('Header',this.Name)
      formData.append('TrainGameId',this.gameId)
      this.$http.addLevelSet(formData)
      .then(res => {
          this.$message.destroy()
          this.$message.success('添加成功')
          this.levelPagelist()
          this.Name = ''
          this.num = 0
      
      });
    },
    deleteLevelSet(record){
      let formData = new FormData()
      formData.append('id',record.id)
      this.$http.deleteLevelSet(formData)
      .then(res => {
          if(record.isadd){
             this.num = 0
          }
          this.$message.destroy()
          this.$message.success('删除成功')
          this.levelPagelist()
          
      });
    },
  }
}
</script>

<style scoped>
/deep/ .searchForm{
  display:flex;
}
/deep/ .searchForm .fold{
    width: 91%;
    display:flex;
  }
</style>
<style scoped lang="less">
.top{
  display:flex;
  .t_l{
    display:flex;
    align-items:center;
    margin-right:15px;
    .t_l_item{
      display: flex;
      align-items: center;
      em{
        display: block;
        font-size: 14px;
        font-style: normal;
        width: 160px;
      }
    }
    .ant-btn-primary{
      display:flex;
      align-items:center;
      justify-content: center;
      padding: 0 20px;
      margin-left: 20px;
    }
  }
}
.bottom{
  margin-top: 15px;
}
.subBox{
  width: 100%;
  display: flex;
  justify-content: center;
  margin-top: 20px;
}
.inputBox{
  display: flex;
  align-items: center;
  em{
    margin: 0 5px;
  }
}
</style>
